module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "wrapper",
    staticClass: "list-wrapper"
  }, [_c('div', {
    staticClass: "scroll-content"
  }, [_c('div', {
    ref: "listWrapper",
    staticClass: "scroll-item"
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("pullup", [(_vm.pullUpLoad) ? _c('div', {
    staticClass: "pullup-wrapper"
  }, [(!_vm.isPullUpLoad) ? _c('div', {
    staticClass: "before-trigger"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t(_vm.pullUpTxt)))])]) : _c('div', {
    staticClass: "after-trigger"
  }, [_c('loading')], 1)]) : _vm._e()], {
    "pullUpLoad": _vm.pullUpLoad,
    "isPullUpLoad": _vm.isPullUpLoad
  })], 2), _vm._v(" "), _vm._t("pulldown", [(_vm.pullDownRefresh) ? _c('div', {
    ref: "pulldown",
    staticClass: "pulldown-wrapper",
    style: (_vm.pullDownStyle)
  }, [(_vm.beforePullDown) ? _c('div', {
    staticClass: "before-trigger"
  }, [_c('bubble', {
    attrs: {
      "y": _vm.bubbleY
    }
  })], 1) : _c('div', {
    staticClass: "after-trigger"
  }, [(_vm.isPullingDown) ? _c('div', {
    staticClass: "loading"
  }, [_c('loading')], 1) : _c('div', [_c('span', [_vm._v(_vm._s(_vm.$t(_vm.refreshTxt)))])])])]) : _vm._e()], {
    "pullDownRefresh": _vm.pullDownRefresh,
    "pullDownStyle": _vm.pullDownStyle,
    "beforePullDown": _vm.beforePullDown,
    "isPullingDown": _vm.isPullingDown,
    "bubbleY": _vm.bubbleY
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3acbd2b4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/modules/Scroll.vue
// module id = 553
// module chunks = 62